export default "__VITE_ASSET__gvhzS$1V__"